import React from 'react'
import Authentication from '../templates/Authentication'
import { ConfirmEmail as Form } from '../molecules/account'

export default function ConfirmEmail() {
    return <Authentication Form={Form} />
}
